import 'core-js/stable'
import Vue from 'vue'
import CoreuiVuePro from '@coreui/vue-pro'
import App from './App'
import router from './router/index'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import i18n from './i18n.js'
import VueKonva from 'vue-konva';
import AuthService from './lib/authservice'
import Api from './lib/api'
import Helper from './utils/helper.js'
import ToastPlugin from './plugins/toast'
import "./index.css";
// Import marketing CSS globally to ensure PostCSS processes it correctly
// The tw- prefix and #marketing-layout scoping prevent conflicts with CoreUI
import "@/assets/css/marketing.css";
// import 'material-icons/iconfont/material-icons.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
//import opencv from './opencv.js';

Vue.use(CoreuiVuePro)
Vue.use(ToastPlugin)
Vue.prototype.$log = console.log.bind(console)

Vue.use(VueKonva);

window.apiUrl = window.config.API_URL;
window.api = new Api();
window.auth = new AuthService();
window.helper = new Helper();

// Proactive token validation on app initialization
if (window.auth.token) {
  const isValid = window.auth.validateToken();

  if (!isValid) {
    window.auth.logout();
  } else {
    // Check if user data is complete (profileId must exist)
    if (window.auth.user && window.auth.user.userData) {
      const profileId = window.auth.user.userData.profileId;

      if (!profileId) {
        window.auth.logout();
      }
    } else {
      window.auth.logout();
    }
  }
}

// window.business = new BusinessHelper();
// window.drawing = new DrawingHelper();


new Vue({
  el: '#app',
  router,
  store,
  //CIcon component documentation: https://coreui.io/vue/docs/components/icon
  icons,
  i18n,
  template: '<App/>',
  components: {
    App
  }
})
